<div class="grid-container padding-y-4">
  <div class="grid-row">
    <div class="grid-col flex-auto">
      <legend class="usa-legend usa-legend--large">{{permission}} - Notify Users</legend>
    </div>
  </div>
  <form [formGroup]="notifyUsersForm">
    <fieldset class="usa-fieldset">
      <div class="grid-row grid-gap">
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
          <div class="grid-row">

            @if (this.permission == 'HHG & FRT' ) {
              <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                <label for="bus_type" class="usa-label">Business Type<abbr title="required" class="usa-hint usa-hint--required">*</abbr></label>
                <select id="bus_type" class="usa-select" formControlName="busType" (change)="businessTypeChange($event.target.value)" required>
                  <option value = '' selected disabled>Choose...</option>
                  <option value='FRT' >FRT</option>
                  <option value='HHG' >HHG</option>
                </select>
              </div>
            }

            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
              <label for="users_type" class="usa-label">Users Type<abbr title="required" class="usa-hint usa-hint--required">*</abbr></label>
              <select id="users_type" class="usa-select" formControlName="usersType" (change)="usersTypeChange($event.target.value)" required>
                <option value ='' selected disabled>Choose...</option>
                <option value='agency' >Agency</option>
                <option value='tsp' >TSP</option>
                <option value='tempNonUseTsps' >Temp Non-Use TSPs</option>
                @if (this.permission == 'FRT' ) {
                  <option value='processingTsps' >Processing TSPs</option>
                }
              </select>
            </div>

            @if (this.usersType == 'agency') {
              <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12" >
                <label for="user_sub_type" class="usa-label">Users Sub Type<abbr title="required" class="usa-hint usa-hint--required">*</abbr></label>
                <select id="user_sub_type" class="usa-select" formControlName="usersSubType" (change)="userSubTypeChange($event.target.value)" required>
                  <option value ='' selected disabled>Choose...</option>
                  <option value='user' >Agency Users</option>
                  <option value='ro' >Agency Authorized Officials</option>
                  <option value='API' >Agency API Customers</option>
                </select>
              </div>
            }

            @if ((this.usersType == 'tsp' || this.usersType == 'tempNonUseTsps' || this.usersType == 'processingTsps') && this.permission == 'FRT' ) {
              <div  class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                <label for="user_sub_type" class="usa-label">Users Sub Type<abbr title="required" class="usa-hint usa-hint--required">*</abbr></label>
                <select id="user_sub_type" class="usa-select" formControlName="usersSubType"
                  (change)="userSubTypeChange($event.target.value)" required>
                  <option value='' selected disabled>Choose...</option>
                  <option value='user' >TSP Users</option>
                  <option value='ro' >TSP Authorized Officials</option>
                </select>
              </div>
            }

            @if ((this.usersType == 'tsp' || this.usersType == 'tempNonUseTsps') && this.permission == 'HHG' ) {
              <div  class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                <label for="user_sub_type" class="usa-label">Users Sub Type<abbr title="required" class="usa-hint usa-hint--required">*</abbr></label>
                <select id="user_sub_type" class="usa-select" formControlName="usersSubType"
                  (change)="userSubTypeChange($event.target.value)" required>
                  <option value='' selected disabled>Choose...</option>
                  <option value='user' >TSP Users</option>
                  <option value='ro' >TSP Authorized Officials</option>
                </select>
              </div>
            }

            @if ((this.usersType == 'tsp' || this.usersType == 'tempNonUseTsps') && this.permission == 'HHG' ) {
              <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                <div class="usa-checkbox">
                  <input class="usa-checkbox__input" id="rfspInclude"  type="checkbox" formControlName="rfspInclude" (click)="rfspIncludeCheck($event)" />
                  <label class="usa-checkbox__label" for="rfspInclude" >check to include RFSPs</label>
                </div>
              </div>
            }
            <div>&nbsp;</div>
            @if (viewRecipientButton) {
              <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                <button type="button" class="usa-button" (click) = "viewRecipientList()" >View Recipients</button>
              </div>
            }

          </div>

        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
          <div class="grid-row">
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
              <label for="email" class="usa-label">Email Subject<abbr title="required" class="usa-hint usa-hint--required">*</abbr></label>
              <input type="text" formControlName="emailSubject" id="email_subject" value= "{{subjectPrefix}}" class="usa-input" maxlength="254">
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
              <label for="email_body" class="usa-label">Email Body <abbr title="required" class="usa-hint usa-hint--required">*</abbr></label>
              <textarea id="email_body" class="usa-textarea" maxlength="5000" formControlName="emailBody"></textarea>
            </div>

            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12" id="selected_files">
            </div>




            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
              <!-- <app-multi-file-upload  [sentEmails]="sentEmails" (gotUploadedFiles)="updateUploadedFiles($event)"></app-multi-file-upload> -->
              <div class="usa-form-group">
                <label class="usa-label" for="file-input-multiple">Input accepts multiple files</label>
                <span class="usa-hint" id="file-input-multiple-hint">Select one or more files</span>
                <div></div>
                <div class="usa-file-input">
                  <div class="usa-sr-only" aria-live="polite">No file selected.</div>
                  <div class="usa-file-input__target">
                    <div class="usa-file-input__box"></div>
                    <div class="usa-file-input__preview" id="selected_files" aria-hidden="true">
                    </div>
                    <div class="usa-file-input__instructions usa-file-input__instructions-custom" aria-hidden="true">
                      <span class="usa-file-input__drag-text">Drag files here or </span>
                      <span class="usa-file-input__choose">choose from folder</span>
                    </div>
                    <input id="file-input-multiple" class="usa-file-input__input" type="file" name="file-input-multiple"
                      aria-describedby="file-input-multiple-hint" multiple="multiple"
                      aria-label="Drag file here or choose from folder" accept=".pdf,.txt,.docx"
                      (change)="onFilesSelected($event)">
                  </div>
                </div>
              </div>
              @if (fileError) {
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                  <div class="usa-alert usa-alert--error maxw-full">
                    <div class="usa-alert__body">
                      <p class="usa-alert__text">
                        {{fileError}}
                      </p>
                    </div>
                  </div>
                </div>
              }
            </div>
            @if (this.exceededUploadLimit) {
              <div class="grid-row grid-gap-0">
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                  <p style="color:red;"><strong>The attached file(s) of total size {{uploadLimit}}MB has exceeded 40 MB limit.</strong></p>
                </div>
              </div>
            }
            @if (this.withinUploadLimit) {
              <div class="grid-row grid-gap-0">
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                  <p style="color:green;"><strong>{{fileCount}} file(s) of total size {{uploadLimit}}MB will be attached to the email.</strong></p>
                </div>
              </div>
            }
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12 padding-top-105">
              <ul class="usa-button-group">
                <li class="usa-button-group__item">
                  <button type="button" class="usa-button " [disabled]="this.notifyUsersForm.invalid || this.exceededUploadLimit || fileError"
                  (click) = "submit()">Send Email</button>
                </li>
                <li class="usa-button-group__item">
                  <button type="button" class="usa-button " [disabled]="this.notifyUsersForm.invalid || this.exceededUploadLimit || fileError" (click) = "onClickReviewEmail()">Preview Email</button>
                </li>
              </ul>

            </div>
          </div>
        </div>
      </div>
    </fieldset>
  </form>
</div>
